import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError, map, switchMap, tap, withLatestFrom, concatMap, mapTo } from 'rxjs/operators';
import { Actions, ofType, Effect } from '@ngrx/effects';
import { Action, Store, select } from '@ngrx/store';
import * as contactActions from '../actions/contact.actions';
import * as fromUI from '../actions/ui.actions';
import { of } from 'rxjs'; 
import { ContactService } from '../../shared/services/contact.service';
import { MessageService } from 'primeng/api';

@Injectable()
export class ContactEffect {

    @Effect()
    loadContacts$: Observable<any> = this.actions$.pipe(
        ofType(contactActions.LOAD_CONTACTS), 
        switchMap((action) => {   
            return this.contactService.getAll(        action['sortField'],
                action['sortOrder'],
                action['filters'],
                action['first'],
                action['rows'], 
                ).pipe(
                map((res: any) => new contactActions.LoadContactsSuccessAction(res.body,parseInt(res.headers.get('X-Pagination-Total-Count')))),
                catchError(error => of(new contactActions.LoadContactsErrorAction(error)))
            );
        })        
    );

    @Effect()
    openTab$: Observable<any> = this.actions$.pipe(
        ofType(contactActions.OPEN_TAB),        
        switchMap((action) => {            
            return this.contactService.get(action['id']).pipe(
                map((res: any) => new contactActions.LoadContactSuccessAction(res)),
                catchError(error => of(new contactActions.LoadContactErrorAction(error)))
            );
        })
    );    
    @Effect()
    saveContact$: Observable<any> = this.actions$.pipe(
        ofType(contactActions.SAVE_CONTACT),        
        switchMap((action) => {            
            return this.contactService.save(action['contact']).pipe(
                map((res: any) => new contactActions.SaveContactSuccessAction(action['contact']['id'], res)),
                catchError(error => of(new contactActions.SaveContactErrorAction(action['contact']['id'], error)))
            );
        })
    );    

    @Effect({ dispatch: false })
    addContact: Observable<any> = this.actions$.pipe(
        ofType(contactActions.ADD_CONTACT),        
        concatMap(action =>
            of(action).pipe(
              withLatestFrom(this.store.pipe(select('contact')))
            )
        ),        
        tap(a => {
               this.router.navigateByUrl('/contact/view/' + a[1].lastNewId);
        })

    );

    @Effect({ dispatch: false })
    closeTab$: Observable<any> = this.actions$.pipe(
        ofType(contactActions.CLOSE_TAB),        
        concatMap(action =>
            of(action).pipe(
              withLatestFrom(this.store.pipe(select('contact')))
            )
        ),        
        tap(a => {
            this.router.navigateByUrl('/contact/list');
        })

    );

    constructor(
        private actions$: Actions,
        private store: Store<any>,
        private router: Router,
        private contactService: ContactService,        
    ) {}
}
